import { Divider, IconButton, type IconButtonProps, Stack, Tooltip } from "@mui/material";
import React from "react";

export interface AdminTableAction {
  icon: React.ReactNode;
  hint: React.ReactNode;
  action: () => void;
  ariaLabel?: string;
  disabled?: boolean;
  color?: IconButtonProps["color"];
  dividerBefore?: boolean;
}

interface AdminTableActionsProps {
  actions: AdminTableAction[];
  colors?: IconButtonProps["color"][];
}

/** Consistent icon actions for the final column of admin tables. */
export const AdminTableActions: React.FC<AdminTableActionsProps> = ({ actions, colors }) => (
  <Stack
    direction="row"
    spacing={0.5}
    useFlexGap
    justifyContent="flex-end"
    sx={{ maxWidth: "100%", flexWrap: { xs: "wrap", md: "nowrap" } }}
  >
    {actions.map((item, index) => (
      <React.Fragment key={item.ariaLabel ?? index}>
        {item.dividerBefore && <Divider orientation="vertical" flexItem sx={{ mx: 0.25 }} />}
        <Tooltip title={item.hint}>
          <span>
            <IconButton
              size="small"
              color={colors?.[index] ?? item.color ?? "primary"}
              onClick={(event) => {
                event.stopPropagation();
                item.action();
              }}
              aria-label={item.ariaLabel ?? (typeof item.hint === "string" ? item.hint : undefined)}
              disabled={item.disabled}
              sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
            >
              {item.icon}
            </IconButton>
          </span>
        </Tooltip>
      </React.Fragment>
    ))}
  </Stack>
);
